<template>
	<div class="notice d-flex j-sb a-start">
		<div class="send">
			<div class="head">发布新通告</div>
			<div class="edit d-flex flex-column j-sb a-end">
				<input type="text" v-model="title"
					style="height: 2.81rem;width: 100%;box-sizing: border-box;
					outline: none;border: none;background: #F6F9FF;color: #666666;padding: 0 0.94rem;"
					placeholder="请输入公告标题">
				<textarea class="flex-1" name="" id="" cols="30" rows="10" v-model="content"
					style="resize: none; width: 100%;margin: 1.38rem 0; box-sizing: border-box;outline: none;border: none;background: #F6F9FF;color: #666666;padding: 0.94rem;"
					placeholder="请输入公告内容"></textarea>
				<div @click="addNotice" style="cursor: pointer;width: 9.38rem;height: 1.88rem;line-height: 1.88rem; background: #1E69FF;color: #FFFFFF;border-radius: 0.94rem;text-align: center;">
					发布</div>
			</div>
		</div>
		<div class="record">
			<div class="head">通告记录</div>
			<div v-if="notice_list" class="infinite-list-wrapper"
				style="overflow:auto; height: 44.82rem;margin-top: 1.25rem;">
				<ul class="list" v-infinite-scroll="load" infinite-scroll-distance="100"
					infinite-scroll-disabled="disabled">
					<li v-for="(item,index) in notice_list" :key="index"
						class="list-item message d-flex flex-column j-sb a-center">
						<div class="w-100 d-flex j-sb a-center">
							<span style="font-size: 0.88rem;font-weight: bold;">{{item.msg_title}}</span>
							<span style="font-size: 0.75rem;">{{$getDate(item.msg_time)}}</span>
						</div>
						<p style="font-size: 0.75rem;width: 100%;">{{item.msg_content}}</p>
					</li>
				</ul>
				<p v-if="loading" style="text-align: center;">加载中...</p>
				<p v-if="noMore" style="text-align: center;">没有更多了</p>
			</div>
			<img v-if="!notice_list" src="../../assets/notice/zanwurenhejilu@2x.png" alt=""
				style="width: 10.38rem;height: 10.38rem;display: block; margin: 0 auto;">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title:'',
				content:'',
				loading: false,
				notice_list: []
			}
		},
		methods: {
			load() {
			},
			addNotice(){
				if(this.title == ''){
					this.$message({
						showClose: false,
						message: '标题不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				
				if(this.content == ''){
					this.$message({
						showClose: false,
						message: '内容不能为空',
						type: 'error',
						offset: 350
					})
					return
				}
				
				let params = {
					act:'add_notice',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					title:this.title,
					content:this.content
				}
				this.$api.addNotice(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350
						})
						this.noticeList()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					this.title = ''
					this.content = ''
				})
			},
			noticeList(){
				let params = {
					act:'notice_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page:1,
					size:99
				}
				this.$api.noticeList(params).then((res)=>{
					if(res.code == 0){
						this.notice_list = res.data.notice_list
					}
				})
			}
		},
		mounted() {
			this.noticeList()
		},
		computed: {
			noMore() {
				return this.notice_list.length >= 30
			},
			disabled() {
				return this.loading || this.noMore
			}
		}
	}
</script>

<style lang="scss" scoped>
	@mixin common {
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 1.25rem;
		box-sizing: border-box;
	}

	@mixin head {
		@include common;
		height: 3.75rem;
		font-size: 1rem;
		font-weight: bold;
		padding: 0 1.44rem;
		line-height: 3.75rem;
	}

	.notice {
		max-width: 73.24rem;
		margin: 0 auto;

		.send {

			flex: 1;

			.head {
				@include head;
			}

			.edit {
				@include common;
				height: 44.82rem;
				width: 100%;
				padding: 1.44rem;
			}
		}

		.record {
			flex: 1;
			margin-left: 1.38rem;

			.head {
				@include head;
			}

			.list {
				.message {
					margin-bottom: 1.25rem;
					background: #FFFFFF;
					height: 6.88rem;
					width: 100%;
					border-radius: 6px;
					padding: 1.19rem 1.31rem;
					box-sizing: border-box;
				}
			}
		}
	}
</style>
